import { connect } from 'react-redux';

import {
	updateRecipe,
	addRecipe,
	requestRecipeId,
	deleteRecipe
} from '../actions/recipe';
import RecipeList from '../components/organisms/RecipeList';

const mapStateToProps = ({createQuiz}) => {
	const {recipe,recipes,error} = createQuiz;
	return {
		recipes,
		currentRecipeId:recipe ? recipe.id : null,
		error
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
		onChangeRecipeName: (newName, recipeId)=>{
			dispatch(updateRecipe({ name : newName}, recipeId));
		},
		onClickRecipe:(recipe)=>{
			dispatch(requestRecipeId(recipe.id));
		},
		onAddRecipe: (recipeName) => {
			if(recipeName&&recipeName!=='')
				dispatch(addRecipe(recipeName));
		},
		onClickDelete: (recipe) => {
			dispatch(deleteRecipe(recipe));
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(RecipeList);